import React, { useContext } from 'react'
import AddLoanProvider from '../components/LoanCalculator/AddLoanProvider'
import AllLoanProviders from '../components/LoanCalculator/AllLoanProviders'
import LoanCalculator from '../components/LoanCalculator/LoanCalculator'
import StateContext from '../StateContext'

function LoanCalculatorPage() {

    const appState = useContext(StateContext)

    return (
        <div className="container my-3 fullHeight">
            <div className="col-lg-6 mx-auto">
                <div className="card my-4">
                    <div className="card-header">Boliglånskalkulator</div>
                    <div className="card-body">
                        <LoanCalculator />
                    </div>  
                </div>
            </div>

            {appState.loggedIn && (
                <div className="col-lg-6 mx-auto">
                    <h4>Legg til låneleverandør / bank</h4>
                    <AddLoanProvider />
                    <h4 className="mt-5">Alle låneleverandører</h4>
                    <AllLoanProviders />
                </div>
            )}
        </div>
    )
}
export default LoanCalculatorPage